// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Mapre_web__Web_tool_call from "./web_tool_call.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function field(json, name) {
  const fields = Js__Js_json.decodeObject(json);
  if (fields !== undefined) {
    return Stdlib__Option.value(Js__Js_dict.get(Caml_option.valFromOption(fields), name), null);
  } else {
    return null;
  }
}

function text(json, name) {
  return Stdlib__Option.value(Js__Js_json.decodeString(field(json, name)), "");
}

function role(param) {
  switch (param) {
    case "admin" :
      return /* Admin */ 1;
    case "member" :
      return /* Member */ 2;
    case "owner" :
      return /* Owner */ 0;
    case "viewer" :
      return /* Viewer */ 3;
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_role"
        });
  }
}

function workspaces(json) {
  return Stdlib__Array.to_list(Stdlib__Array.map((function (row) {
    return {
      id: Mapre_wire__Json.string(row, "id"),
      name: Mapre_wire__Json.string(row, "name"),
      role: role(Mapre_wire__Json.string(row, "role"))
    };
  }), Mapre_wire__Json.array(json, "workspaces")));
}

function projects(json) {
  return Stdlib__Array.to_list(Stdlib__Array.map((function (row) {
    return {
      id: Mapre_wire__Json.string(row, "id"),
      name: Mapre_wire__Json.string(row, "name"),
      repository: Mapre_wire__Json.string(row, "repository_full_name"),
      version: Mapre_wire__Json.integer(row, "version"),
      base_branch: Mapre_wire__Json.string(row, "base_branch")
    };
  }), Mapre_wire__Json.array(json, "projects")));
}

function session(row) {
  const id = Js__Js_json.decodeString(Mapre_wire__Json.get(row, "parent_id"));
  let tmp;
  if (id !== undefined) {
    tmp = id;
  } else if (Caml_obj.caml_equal(Mapre_wire__Json.get(row, "parent_id"), null)) {
    tmp = undefined;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_parent"
      });
  }
  const value = Js__Js_json.decodeNumber(Mapre_wire__Json.get(row, "created_at"));
  let tmp$1;
  if (value !== undefined) {
    tmp$1 = value;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_created_at"
      });
  }
  return {
    id: Mapre_wire__Json.string(row, "id"),
    parent_id: tmp,
    title: Mapre_wire__Json.string(row, "title"),
    status: Mapre_wire__Json.string(row, "status"),
    created_at: tmp$1
  };
}

function sessions(json) {
  return Stdlib__Array.to_list(Stdlib__Array.map(session, Mapre_wire__Json.array(json, "sessions")));
}

function templates(json) {
  return Stdlib__Array.to_list(Stdlib__Array.map((function (row) {
    return {
      id: Mapre_wire__Json.string(row, "id"),
      revision: Mapre_wire__Json.integer(row, "revision")
    };
  }), Mapre_wire__Json.array(json, "templates")));
}

function subscriptions(json) {
  return Stdlib__Array.to_list(Stdlib__Array.map((function (row) {
    const ownership = Mapre_wire__Json.string(row, "ownership");
    const provider = Mapre_wire__Json.string(row, "provider");
    if (!Stdlib__List.mem(ownership, {
        hd: "personal",
        tl: {
          hd: "shared",
          tl: /* [] */ 0
        }
      }) || !Stdlib__List.mem(provider, {
        hd: "chatgpt",
        tl: {
          hd: "devin",
          tl: {
            hd: "cursor",
            tl: {
              hd: "grok",
              tl: /* [] */ 0
            }
          }
        }
      })) {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_subscription"
        });
    }
    return {
      id: Mapre_wire__Json.string(row, "id"),
      label: Mapre_wire__Json.string(row, "label"),
      provider,
      authorization_version: Mapre_wire__Json.integer(row, "authorization_version"),
      status: Mapre_wire__Json.string(row, "status"),
      ownership,
      owner_login: Mapre_wire__Json.string(row, "owner_login"),
      expires_at: Js__Js_json.decodeNumber(Mapre_wire__Json.get(row, "expires_at")),
      quota_reset_at: Js__Js_json.decodeNumber(Mapre_wire__Json.get(row, "quota_reset_at")),
      verified: Caml_obj.caml_notequal(Mapre_wire__Json.get(row, "verified_at"), null)
    };
  }), Mapre_wire__Json.array(json, "connections")));
}

function content(data) {
  const params = field(data, "params");
  const update = field(params, "update");
  if (text(data, "method") === "session/request_permission") {
    return "Permission requested. Review the command above.";
  }
  const match = text(update, "sessionUpdate");
  switch (match) {
    case "tool_call" :
    case "tool_call_update" :
      return text(update, "title");
    case "agent_message_chunk" :
    case "agent_thought_chunk" :
    case "user_message_chunk" :
      break;
    default:
      const direct = text(data, "text");
      if (direct !== "") {
        return direct;
      }
      const nested = text(params, "text");
      if (nested !== "") {
        return nested;
      } else {
        return JSON.stringify(data);
      }
  }
  return text(field(update, "content"), "text");
}

function $$event(row) {
  const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(row, "truncated"));
  let truncated;
  if (value !== undefined) {
    truncated = value;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_truncated"
      });
  }
  let tmp;
  if (truncated) {
    tmp = "Event payload is available on request.";
  } else if (Mapre_wire__Json.string(row, "type") === "command_result") {
    const data = Mapre_wire__Json.get(row, "data");
    if (text(data, "status") === "failed") {
      const reason = text(data, "error");
      tmp = reason === "" ? "Command failed" : "Command failed: " + reason;
    } else {
      tmp = "";
    }
  } else {
    tmp = Mapre_wire__Json.string(row, "type") === "user_message" ? text(Mapre_wire__Json.get(row, "data"), "text") : content(Mapre_wire__Json.get(row, "data"));
  }
  let tmp$1;
  if (truncated) {
    tmp$1 = undefined;
  } else {
    const id = Js__Js_json.decodeString(field(Mapre_wire__Json.get(row, "data"), "command_id"));
    tmp$1 = id !== undefined && id !== "" ? id : undefined;
  }
  return {
    attachments: truncated ? /* [] */ 0 : Mapre_web__Web_attachments_model.decode_list(field(Mapre_wire__Json.get(row, "data"), "attachments")),
    seq: Mapre_wire__Json.integer(row, "position"),
    revision: Mapre_wire__Json.integer(row, "seq"),
    run_id: Mapre_wire__Json.string(row, "run_id"),
    source_epoch: Mapre_wire__Json.string(row, "source_epoch"),
    kind: Mapre_wire__Json.string(row, "type"),
    text: tmp,
    truncated,
    permission_update: truncated || Mapre_wire__Json.string(row, "type") === "command_result" || text(Mapre_wire__Json.get(row, "data"), "method") === "session/request_permission",
    tool: truncated ? undefined : Mapre_web__Web_tool_call.decode(Mapre_wire__Json.get(row, "data")),
    command_id: tmp$1,
    actor: truncated || Mapre_wire__Json.string(row, "type") !== "user_message" ? undefined : Js__Js_json.decodeString(field(Mapre_wire__Json.get(row, "data"), "actor_login"))
  };
}

function events(json) {
  return Stdlib__Array.to_list(Stdlib__Array.map($$event, Mapre_wire__Json.array(json, "events")));
}

function admission(row) {
  if (Mapre_wire__Json.string(row, "state") !== "pending" || Mapre_wire__Json.string(row, "kind") !== "prompt" || Mapre_wire__Json.string(row, "source_run_id") === "") {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_admission"
      });
  }
  return {
    attachments: Mapre_web__Web_attachments_model.decode_list(Mapre_wire__Json.array(row, "attachments")),
    id: Mapre_wire__Json.string(row, "command_id"),
    actor: Mapre_wire__Json.string(row, "actor_id"),
    state: "pending",
    kind: "prompt",
    text: Mapre_wire__Json.text(row, "text"),
    in_timeline: false
  };
}

function commands(json) {
  const admissions = Mapre_wire__Json.array(json, "admissions");
  if (admissions.length > 64) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "admissions_exceeded"
      });
  }
  return Stdlib.$at(Stdlib__Array.to_list(Stdlib__Array.map((function (row) {
    const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(row, "in_timeline"));
    let tmp;
    if (value !== undefined) {
      tmp = value;
    } else {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_command_timeline"
        });
    }
    return {
      attachments: Mapre_web__Web_attachments_model.decode_list(field(Mapre_wire__Json.get(row, "command"), "attachments")),
      id: Mapre_wire__Json.string(row, "command_id"),
      actor: Mapre_wire__Json.string(row, "actor_id"),
      state: Mapre_wire__Json.string(row, "state"),
      kind: Mapre_wire__Json.string(Mapre_wire__Json.get(row, "command"), "kind"),
      text: text(Mapre_wire__Json.get(row, "command"), "text"),
      in_timeline: tmp
    };
  }), Mapre_wire__Json.array(json, "commands"))), Stdlib__Array.to_list(Stdlib__Array.map(admission, admissions)));
}

function events_frame(json) {
  const from = Mapre_wire__Json.integer(json, "from_seq");
  const upto = Mapre_wire__Json.integer(json, "upto");
  const events$1 = events(json);
  const last = Stdlib__List.fold_left((function (previous, $$event) {
    if ($$event.revision <= previous || $$event.revision > upto) {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_event_order"
        });
    }
    return $$event.revision;
  }), from, events$1);
  if (last > upto) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_event_watermark"
      });
  }
  return [
    from,
    upto,
    events$1
  ];
}

function control(value) {
  const match = Js__Js_json.decodeString(value);
  if (match !== undefined) {
    switch (match) {
      case "checkpoint" :
        return /* Checkpoint */ 3;
      case "commands" :
        return /* Commands */ 1;
      case "comments" :
        return /* Comments */ 4;
      case "permissions" :
        return /* Permissions */ 5;
      case "publication" :
        return /* Publication */ 2;
      case "session" :
        return /* Session */ 0;
      default:
        throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
            MEL_EXN_ID: Mapre_wire__Json.Invalid,
            _1: "invalid_control_name"
          });
    }
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_control_name"
      });
  }
}

function controls_frame(json) {
  const run_id = Mapre_wire__Json.string(json, "run_id");
  if (run_id.length === 0 || run_id.length > 128 || !Stdlib__String.for_all((function (param) {
      if (param >= 65) {
        if (param > 96 || param < 91) {
          return param < 123;
        } else {
          return param === 95;
        }
      } else if (param > 57 || param < 45) {
        return false;
      } else {
        return param !== 47;
      }
    }), run_id)) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_controls_run_id"
      });
  }
  const version = Mapre_wire__Json.integer(json, "version");
  if (version < 0 || version > 2147483647) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_controls_version"
      });
  }
  const controls = Stdlib__List.map(control, Stdlib__Array.to_list(Mapre_wire__Json.array(json, "controls")));
  if (controls) {
    return [
      run_id,
      version,
      controls
    ];
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_controls_frame"
    });
}

function frame(json) {
  if (Mapre_wire__Json.integer(json, "v") !== 2) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_event_frame"
      });
  }
  const match = Mapre_wire__Json.string(json, "type");
  switch (match) {
    case "controls" :
      const match$1 = controls_frame(json);
      return {
        TAG: /* Controls */ 1,
        _0: match$1[0],
        _1: match$1[1],
        _2: match$1[2]
      };
    case "events" :
      const match$2 = events_frame(json);
      return {
        TAG: /* Events */ 0,
        _0: match$2[0],
        _1: match$2[1],
        _2: match$2[2]
      };
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_event_frame"
        });
  }
}

export {
  field,
  text,
  workspaces,
  projects,
  session,
  sessions,
  templates,
  subscriptions,
  $$event,
  events,
  commands,
  frame,
}
/* Mapre_web__Web_attachments_model Not a pure module */
